// Adds a callback to window scroll
export const scrollTo = ( offset:number, callback: () => void, scrollUp?: boolean) => {
    // console.log('offset ', offset);
    // console.log('scrollHeight ', document.documentElement.scrollHeight)
    // console.log('window.', window.innerHeight);
    const onScroll = function () {
        // console.log(offset)
        if (!scrollUp) {
            // Second part is if scrolled to bottom of page.
            if (window.pageYOffset >= offset || (window.pageYOffset === document.documentElement.scrollHeight - window.innerHeight)) {
                // console.log(window.pageYOffset >= offset)
                window.removeEventListener('scroll', onScroll);
                callback()
            }
        } else {
            if ((window.pageYOffset-20) <= offset || window.pageYOffset === 0) {
                // console.log('hit')
                window.removeEventListener('scroll', onScroll);
                callback()
            }
        }
    }

    window.addEventListener('scroll', onScroll)
    onScroll()
    window.scrollTo({
        top: offset,
        behavior: 'smooth'
    })
}
